var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.5V17.5C1 16.4391 1.42143 15.4217 2.17157 14.6716C2.92172 13.9214 3.93913 13.5 5 13.5H9C10.0609 13.5 11.0783 13.9214 11.8284 14.6716C12.5786 15.4217 13 16.4391 13 17.5V19.5M14 1.62988C14.8604 1.85018 15.623 2.35058 16.1676 3.05219C16.7122 3.7538 17.0078 4.61671 17.0078 5.50488C17.0078 6.39305 16.7122 7.25596 16.1676 7.95757C15.623 8.65918 14.8604 9.15958 14 9.37988M19 19.5V17.5C18.9949 16.6172 18.6979 15.7608 18.1553 15.0644C17.6126 14.368 16.8548 13.8707 16 13.65M3 5.5C3 6.56087 3.42143 7.57828 4.17157 8.32843C4.92172 9.07857 5.93913 9.5 7 9.5C8.06087 9.5 9.07828 9.07857 9.82843 8.32843C10.5786 7.57828 11 6.56087 11 5.5C11 4.43913 10.5786 3.42172 9.82843 2.67157C9.07828 1.92143 8.06087 1.5 7 1.5C5.93913 1.5 4.92172 1.92143 4.17157 2.67157C3.42143 3.42172 3 4.43913 3 5.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeWell);
export default __webpack_public_path__ + "static/media/employee_well.e65bd98971920f7f4c9d68cd261cc4be.svg";
export { ForwardRef as ReactComponent };